import { inject, Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { VisualizarModulesService } from './visualizar-modules.service';
import { catchError, map, of, tap } from 'rxjs';
import { Helperclass } from '../class/helperclass';
import { UtilityService } from './utility.service';
import { Permissions } from '../enums/permission.enum';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  readonly #tokenService = inject(TokenService);
  readonly #utilityService = inject(UtilityService);
  readonly #visualizarModulesService = inject(VisualizarModulesService);
  readonly #helperClass = inject(Helperclass);



  loadUserSession() {
    if (!this.#tokenService.isValidToken()) {
      return of(false);
    }

    const token = sessionStorage.getItem('tokenMotor')!;
    const agentID = sessionStorage.getItem('agentID')!;

    return this.#visualizarModulesService.getModules({
      token,
      route: 'usuarioModulos',
      agentID
    }).pipe(
      tap(response => {
        const { modulosActivos, ...rest } = response;

        const getDashboardModules = modulosActivos.filter(m => m.portal === 'ADMIN MOTOR' && m.patch?.includes('dashboard'));
        const containsActiveModules = getDashboardModules.filter(m => m.accion.some(a => a === Permissions.VIEW));

        this.#helperClass.setActiveModules(containsActiveModules);
        sessionStorage.setItem('dataMotor', JSON.stringify(rest));
        sessionStorage.setItem('menu', JSON.stringify(containsActiveModules));
        this.#utilityService.IsLogin$.next(true);
      }),
      map(() => true),
      catchError(() => of(false))
    );
  }
}
